import React, { useEffect, useState } from "react";
import "../CreateClinicalNote/CreateClinicalNote.css";

import LocationForm from "../CreateClinicalNote/CreateClinicalNoteComp/LocationForm";
import VitalsForm from "../CreateClinicalNote/CreateClinicalNoteComp/VitalsForm";
import HpiForm from "../CreateClinicalNote/CreateClinicalNoteComp/HpiForm";
import Phq2Form from "../CreateClinicalNote/CreateClinicalNoteComp/Phq2Form";
import AssessmentsPlanFollowUp from "../CreateClinicalNote/CreateClinicalNoteComp/AssessmentsPlanFollowUp";
import ActionsBar from "../CreateClinicalNote/CreateClinicalNoteComp/ActionsBar";
import RosFormTemplates from "../CreateClinicalNote/CreateClinicalNoteComp/RosFormTemplates";
import ExamFormTemplates from "../CreateClinicalNote/CreateClinicalNoteComp/ExamFormTemplates";

import buildEhrNotePayload from "../../../utils/services/APP/ClinicalNotes/buildEhrNotePayload";
import { addEhrNote } from "../../../utils/services/AdvancedMD/ehrNotes";

const toUsDatetime = (date = new Date()) => {
  const d = new Date(date);
  const pad = (n) => (n < 10 ? `0${n}` : n);
  const h = d.getHours();
  const hour12 = ((h + 11) % 12) + 1;
  const ampm = h >= 12 ? "PM" : "AM";
  return `${pad(d.getMonth() + 1)}/${pad(d.getDate())}/${d.getFullYear()} ${pad(hour12)}:${pad(d.getMinutes())}:00 ${ampm}`;
};

export default function CreateHospitalDischargeFollowUpNote({ patientId, onCancel, onSaved }) {
  const [patient, setPatient] = useState({ patientId: "", profileId: "3" });
  const [meta, setMeta] = useState({ templateName: "_Hospital Discharge Follow Up" });

  const [location, setLocation] = useState({});
  const [reason, setReason] = useState({});
  const [vitals, setVitals] = useState({});
  const [hpi, setHpi] = useState({});
  const [meds, setMeds] = useState({});
  const [pmh, setPmh] = useState({});
  const [ros, setRos] = useState({});
  const [exam, setExam] = useState({});
  const [phq2, setPhq2] = useState({});
  const [assessPlanFu, setAssessPlanFu] = useState({});

  useEffect(() => {
    setPatient({ patientId, profileId: "3" });
    setMeta({
      templateName: "_Hospital Discharge Follow Up",
      comment: "Hospital discharge note - follow-up",
      noteDatetime: toUsDatetime(),
      msgtime: toUsDatetime(),
      nocookie: "0",
    });

    setLocation({
      location: "Palm Springs/Lake Worth Sante Plus Medical Center",
      location2: "3155 Lake Worth Rd, Palm Springs, FL-16917",
      location1: "(561) 858-8817 - (561) 878-8277",
    });

    setReason({ ReasonforAppointment: "NP ER Discharge FU" });
  }, [patientId]);

  // Auto BMI
  useEffect(() => {
    if (vitals.Vitals_Height && vitals.Vitals_Weight) {
      const h = parseFloat(vitals.Vitals_Height);
      const w = parseFloat(vitals.Vitals_Weight);
      if (!isNaN(h) && !isNaN(w) && h > 0) {
        const bmi = (w / (h * h)) * 703;
        setVitals((v) => ({ ...v, Vitals_BMI: bmi.toFixed(1) }));
      }
    }
  }, [vitals.Vitals_Height, vitals.Vitals_Weight]);

  const onSave = async () => {
    const payload = buildEhrNotePayload({
      patient,
      meta,
      location,
      reason,
      vitals,
      hpi,
      meds,
      pmh,
      ros,
      exam,
      phq2,
      assessPlanFu,
    });

    try {
      await addEhrNote(payload);
      alert("Note created!");
      onSaved?.();
    } catch (err) {
      alert("Error: " + (err?.message || "Unknown error"));
    }
  };

  return (
    <div className="cn-container">
      <h2>Hospital Discharge Follow Up</h2>

      <LocationForm
        location={location}
        reason={reason}
        onChangeLocation={setLocation}
        onChangeReason={setReason}
        isEditing={true}
      />

      <VitalsForm vitals={vitals} onChange={setVitals} templateId={null} isEditing={true} />
      <HpiForm hpi={hpi} meds={meds} pmh={pmh} onChangeHpi={setHpi} onChangeMeds={setMeds} onChangePmh={setPmh} isEditing={true} />
      <RosFormTemplates ros={ros} onChange={setRos} templateId={null} isEditing={true} />
      <ExamFormTemplates exam={exam} onChange={setExam} isEditing={true} />
      <Phq2Form phq2={phq2} onChange={setPhq2} isEditing={true} />
      <AssessmentsPlanFollowUp data={assessPlanFu} onChange={setAssessPlanFu} isEditing={true} />

      <ActionsBar onSave={onSave} onCancel={onCancel} saveLabel="Create Note" />
    </div>
  );
}
